export default __webpack_public_path__ + "static/media/system-volume-06.fec5e1fb.svg";